export type RepresentativeFilters = {
  countries: string[];
  fields: string[];
  institutionTypes: string[];
  services: string[];
};

export const defaultRepresentativeFilters: RepresentativeFilters = {
  countries: [],
  fields: [],
  institutionTypes: [],
  services: [],
};

export function activeRepresentativeFilterCount(
  f: RepresentativeFilters
): number {
  let n = 0;
  if (f.countries.length > 0) n++;
  if (f.fields.length > 0) n++;
  if (f.institutionTypes.length > 0) n++;
  if (f.services.length > 0) n++;
  return n;
}
